import { createUUID } from "../../../Common";
import { ClearConnectionResults } from "../../../Contracts";
const query_id = new Map();
const id_query = new Map();
const query_connection = new Map();
const connection_query = new Map();
const allStores = [query_id, id_query, query_connection, connection_query];
function srlzQuery(q) { return typeof q === "string" ? q : JSON.stringify(q); }
export const OBQuerySubscribersStore = {
    hasConnection: (r) => {
        return connection_query.has(r);
    },
    hasQuery: (q) => {
        return query_id.has(srlzQuery(q));
    },
    set: (query, connection) => {
        const q = srlzQuery(query);
        const existingQuery = OBQuerySubscribersStore.getQueryForConnection(connection);
        if (existingQuery) {
            if (OBQuerySubscribersStore.getConnectionsForQuery(existingQuery).length <= 1) {
                let id = query_id.get(existingQuery);
                query_id.delete(existingQuery);
                id_query.delete(id);
            }
            OBQuerySubscribersStore.clearConnection(connection);
        }
        if (!query_id.get(q)) {
            const id = createUUID();
            query_id.set(q, id);
            id_query.set(id, q);
        }
        const connections = query_connection.get(q) || [];
        connections.push(connection);
        query_connection.set(q, connections);
        connection_query.set(connection, q);
    },
    getConnectionsForQuery: (q) => {
        return query_connection.get(srlzQuery(q)) || [];
    },
    getQueryForConnection: (r) => {
        return connection_query.get(r);
    },
    getQueryID: (q) => {
        return query_id.get(srlzQuery(q));
    },
    getQueryByID: (id) => {
        return id_query.get(id);
    },
    getAllQueries: () => {
        return [...query_id.keys()];
    },
    getAllConnections: (q) => {
        return [...connection_query]
            .filter(x => q ? srlzQuery(q) === x[1] : true)
            .map(x => x[0]);
    },
    clearConnection: (r) => {
        const q = connection_query.get(r);
        if (!q) {
            return ClearConnectionResults.QueryNotFound;
        }
        // if we have query -> we have the rest
        const connections = query_connection.get(q);
        const i = connections.findIndex(x => x === r);
        connections.splice(i, 1);
        connection_query.delete(r);
        if (connections.length === 0) {
            const id = query_id.get(q);
            query_connection.delete(q);
            id_query.delete(id);
            query_id.delete(q);
            return id;
        }
        return ClearConnectionResults.RemovedConnection;
    },
    clear: () => {
        query_id.clear();
        id_query.clear();
        query_connection.clear();
        connection_query.clear();
    }
};
// exposing a prop on window for easier debugging in development builds
// no need to test it...
/* istanbul ignore next */
if (process.env.NODE_ENV === "development") {
    window["__SB_OB_DATALAYER__QUERYSUBSSTORE"] = OBQuerySubscribersStore;
    window["__SB_OB_DATALAYER__QUERYSUBSSTORES"] = allStores;
}
//# sourceMappingURL=OBQuerySubscribersStore.js.map